import React, { useEffect, useState } from "react";
// import { getBuyerProfile, updateBuyerProfile } from "../../api/buyerProfile.api";
import { updateBuyerProfile } from "../../api/buyerProfile.api";
import { Input, Label, Row, Col, Tooltip } from "reactstrap";
import { toast } from "react-toastify";
import { useAuth } from "../../context/AuthContext";
import StatusBadge from "../../components/StatusBadge";

const BuyerProfile = ({ onBack }) => {
  const [values, setValues] = useState({});
  const { user, setUser } = useAuth();
  const [tooltips, setTooltips] = useState({
    backBtn: false,
    updateBtn: false
  });

  const toggleTooltip = (tooltipName) => {
    setTooltips(prev => ({
      ...prev,
      [tooltipName]: !prev[tooltipName]
    }));
  };

    useEffect(() => {

      if (user && Object.keys(values).length === 0) {

        setValues(user);

      }

    }, [user]);
  
  const handleChange = (e) => setValues({ 
    ...values, [e.target.name]: e.target.value 
  });

const handleUpdate = async () => {

  try {

    const res = await updateBuyerProfile(values);

    if (res.data.isOk) {

      setUser(prev => ({
        ...prev,
        ...values
      }));

      toast.success("Updated");

    }

  } catch (e) {

    toast.error("Update failed");

  }

};

  const inputStyle = { backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "12px" };
  const labelStyle = { color: "#6b7280", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", marginBottom: "5px" };

  return (
    <div className="p-0">
      <button id="backBtn" className="btn btn-link text-dark text-decoration-none fw-bold p-0 mb-4" onClick={onBack}>
        ← Back to Dashboard
      </button>
      <Tooltip placement="right" isOpen={tooltips.backBtn} target="backBtn" toggle={() => toggleTooltip('backBtn')}>
        Return to buyer dashboard
      </Tooltip>

      <div
  style={{
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    padding: "clamp(20px, 4vw, 30px)",
    marginBottom: "24px",
    boxShadow: "0 1px 2px rgba(0,0,0,0.03)"
  }}
>

  <div className="d-flex flex-wrap justify-content-between align-items-start gap-3">

    <div className="d-flex align-items-center gap-3">

      <div
        style={{
          width: "60px",
          height: "60px",
          backgroundColor: "#f3f4f6",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "28px"
        }}
      >
        👤
      </div>

      <div>

        <h3
          className="fw-bold m-0"
          style={{
            color: "#112347",
            fontSize: "clamp(20px, 3vw, 28px)"
          }}
        >
          {values.name || "Buyer"}
        </h3>

        <div className="mt-2">
          <StatusBadge
            status={
              values.verification_status ||
              "VERIFIED"
            }
          />
        </div>

      </div>

    </div>

  </div>

  <div className="mt-4 d-flex align-items-center gap-2 text-muted small">
    <span>📅</span>

    Member since {
      values.created_at
        ? values.created_at.split("T")[0]
        : "---"
    }
  </div>

</div>


      <div style={{ backgroundColor: "#fff", border: "1px solid #e5e7eb", borderRadius: "12px", padding: "clamp(20px, 4vw, 32px)", maxWidth: "800px" }}>
        <h5 className="fw-bold mb-4" style={{ color: "#112347" }}>Edit Your Profile</h5>
        
        <Row className="g-3 g-md-4">
          <Col xs="12">
            <Label style={labelStyle}>Full Name</Label>
            <Input name="name" value={values.name || ""} onChange={handleChange} style={inputStyle} />
          </Col>
          <Col xs="12" md="6">
            <Label style={labelStyle}>Email Address</Label>
            <Input name="email" value={values.email || ""} onChange={handleChange} style={inputStyle} />
          </Col>
          <Col xs="12" md="6">
            <Label style={labelStyle}>Contact Number</Label>
            <Input name="phone_number" value={values.phone_number || ""} onChange={handleChange} style={inputStyle} />
          </Col>
        </Row>

        <button 
          id="updateBtn"
          className="btn btn-dark w-100 w-md-auto fw-bold mt-4 mt-md-5 px-5 py-3" 
          style={{ backgroundColor: "#112347", border: "none", borderRadius: "10px" }} 
          onClick={handleUpdate}
        >
          Update My Profile Information
        </button>
        <Tooltip placement="top" isOpen={tooltips.updateBtn} target="updateBtn" toggle={() => toggleTooltip('updateBtn')}>
          Save your profile changes
        </Tooltip>
      </div>
    </div>
  );
};

export default BuyerProfile;